import GraphicObject from './GraphicObject';

export default class Buffer extends GraphicObject {

	_type = null;
	_itemSize = null;
	_attributeName = null;
	_dynamic = null;
	_itemCount = null;
	_bufferClasses = null;

	constructor(gl, type, attributeName, itemSize, dynamic, bufferClasses) {
		const buffer = gl.createBuffer();
		super(gl, buffer);
		this._type = type;
		this._itemSize = itemSize;
		this._attributeName = attributeName;
		this._dynamic = dynamic;
		this._bufferClasses = bufferClasses;
	}

	getType() {
		return this._type;
	}

	getItemSize() {
		return this._itemSize;
	}

	getAttributeName() {
		return this._attributeName;
	}

	isDynamic() {
		return this._dynamic;
	}
	getItemCount() {
		return this._itemCount;
	}

	update(data) {
		if (this._bufferClasses.filter(Clazz => data instanceof Clazz).length === 0) {
			throw new Error('Incorrect class for buffer data');
		}
		if (data.length % this._itemSize) {
			throw new Error('Data contains an incomplete item');
		}
		this._itemCount = data.length / this._itemSize;
		this._gl.bindBuffer(this._type, this._object);
		if (!data || !data.length) {
			throw new Error('No data provided');
		}
		this._gl.bufferData(this._type, data, this._dynamic ? this._gl.DYNAMIC_DRAW : this._gl.STATIC_DRAW);
	}

	release() {
		this._gl.deleteBuffer(this._object);
		super.release();
	}

}
